import { cn } from './cn';

export interface AvatarProps {
  src?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  size?: number;
  className?: string;
}

/** Foto de perfil o, si no existe, iniciales sobre fondo de marca. */
export function Avatar({ src, firstName, lastName, size = 44, className }: AvatarProps) {
  const initials = `${(firstName ?? '').trim()[0] ?? ''}${(lastName ?? '').trim()[0] ?? ''}`.toUpperCase() || '?';
  const style = { width: size, height: size, fontSize: Math.max(12, size * 0.38) };
  const alt = [firstName, lastName].filter(Boolean).join(' ') || 'Usuario';
  if (src) {
    return <img src={src} alt={alt} style={style} className={cn('rounded-full object-cover bg-brand-gray shrink-0', className)} loading="lazy" />;
  }
  return (
    <span
      role="img"
      aria-label={alt}
      style={style}
      className={cn('inline-flex items-center justify-center rounded-full bg-brand-black text-white font-semibold shrink-0 dark:bg-white dark:text-brand-black', className)}
    >
      {initials}
    </span>
  );
}
